/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// @mui material components
import "rc-tree/assets/index.css";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { find } from "lodash";
import moment from "moment";
import { getMedicos } from "store/catalogos/catalogosActions";

function formCita({ props, onChangeCita }) {
  const { estudiosMedicos, hospitales, medicos } = useSelector((state) => state.catalogos);

  const estudiosMedicosMostrar = useMemo(() => {
    return estudiosMedicos.filter((obj) => obj.activo != false);
  }, [estudiosMedicos]);

  const hospitalesMostrar = useMemo(() => {
    return hospitales.filter((obj) => obj.activo != false);
  }, [hospitales]);

  const dispatch = useDispatch();

  const { estudio, fechaCita, horaCita, lugar, observaciones, idMedico, disabledMedicos } = props;

  return (
    <>
      <Autocomplete
        id="controlled-demo"
        options={estudiosMedicosMostrar}
        getOptionLabel={(option) => option.descripcion}
        value={find(estudiosMedicosMostrar, (opt) => opt.idEstudio === estudio) || null}
        onChange={(event, newValue) => {
          if (newValue != null) {
            if (newValue != null) {
              onChangeCita(newValue.idEstudio, "estudio");
            }
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Estudio" variant="outlined" error={false} />
        )}
        style={{ width: "100%", marginBottom: "1rem" }}
        size="small"
      />
      <TextField
        value={fechaCita}
        onChange={(event) => {
          onChangeCita(event.target.value, "fechaCita");
        }}
        error={false}
        helperText={""}
        onBlur={() => {}}
        variant="outlined"
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        style={{ width: "100%", marginBottom: "1.5rem", cursor: "pointer" }}
        size="small"
        type="date"
        autoComplete="off"
        inputProps={
          {
            //min: moment().format("YYYY-MM-DD"),
          }
        }
        onClick={(e) => e.target.showPicker && e.target.showPicker()}
      />
      <TextField
        type="time"
        value={horaCita}
        onChange={(event) => {
          onChangeCita(event.target.value, "horaCita");
        }}
        label={"Hora"}
        variant="outlined"
        style={{ width: "22%", marginBottom: "1rem" }}
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        onClick={(e) => e.target.showPicker && e.target.showPicker()}
      />
      <Autocomplete
        id="controlled-demo"
        options={hospitalesMostrar}
        getOptionLabel={(option) => option.hospital}
        value={find(hospitalesMostrar, (opt) => opt.idHospital === lugar) || null}
        onChange={(event, newValue) => {
          if (newValue != null) {
            if (newValue != null) {
              onChangeCita(newValue.idHospital, "lugar");
              onChangeCita(newValue.hospital, "nombreLugar");
              getMedicos(dispatch, newValue.idHospital);
              onChangeCita(false, "disabled");
            }
          } else {
            onChangeCita(null, "lugar");
            onChangeCita(true, "disabled");
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Hospital" variant="outlined" error={false} />
        )}
        style={{ width: "100%", marginBottom: "1rem" }}
        size="small"
      />
      <Autocomplete
        id="controlled-demo"
        disabled={disabledMedicos}
        options={medicos}
        getOptionLabel={(option) => option.nombre}
        value={find(medicos, (opt) => opt.idUsuario === idMedico) || null}
        onChange={(event, newValue) => {
          if (newValue != null) {
            onChangeCita(newValue.idUsuario, "idMedico");
            onChangeCita(newValue.nombre, "medico");
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Médico" variant="outlined" error={false} />
        )}
        style={{ width: "100%", marginBottom: "1rem" }}
        size="small"
      />
      <TextField
        value={observaciones}
        onChange={(event) => {
          onChangeCita(event.target.value, "observaciones");
        }}
        label={"Observaciones"}
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem" }}
        multiline
        rows={5}
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
      />
    </>
  );
}

export default formCita;
